import React from "react"
import { Grid } from "@mui/material"

import { AppCrudTable } from "@components"
import { userSettingWebSupplierGroupData } from "../@signals"
import { actionsColumn, nameColumn, webSuppliersColumn } from "./columns"
import WebSupplierGroupTabButton from "./Button"
import WebSupplierGroupDrawer from "./Drawer"


export default function UserSettingWebSupplierGroupTab() {
	return <Grid container spacing={1}>
		<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
			<WebSupplierGroupTabButton />
		</Grid>

		{!!userSettingWebSupplierGroupData.value?.length && <Grid item xs={12}>
			<AppCrudTable
				title="Your Web Supplier Groups"
				data={userSettingWebSupplierGroupData.value}
				columns={[
					nameColumn(),
					webSuppliersColumn(),
					actionsColumn(),
				]}
			/>
		</Grid>}

		<WebSupplierGroupDrawer />
	</Grid>
}